// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__vjdTp","hard_skills_container":"Skills_hard_skills_container__8uakJ"};